export var FONT_FAMILIES = Object.freeze({
  SANS_SERIF: Object.freeze(['"Open Sans"', '"Adjusted Arial"', 'Tahoma', 'Geneva', 'sans-serif']),
  SERIF: Object.freeze(['"Ivar Headline"', '"Ivar Headline Subset"', '"Adjusted Times"', '"Adjusted Times New Roman"', '"Times New Roman"', 'serif'])
});